import { Validation, VariantAttribute } from '@vp/upload-and-print-validator';
import { ProductInformation } from 'src/providers/ProductContextProvider';
import { retrieveFileRequirements } from 'src/services/UploadAndPrintService';
import { getTranslatedNameForProductOptionValue } from './productOptionUtils';

export const getValidationsForProduct = async (product: ProductInformation): Promise<Validation[]> => {
  try {
    return await retrieveFileRequirements(product.productKey, product.productVersion, product.selectedOptions);
  } catch (e) {
    return [];
  }
};

export const hasValidationErrors = (validations: Validation[] | null): boolean => {
  return validations !== null && validations.filter(v => v.state === 'Error').length > 0;
};

export const processValidations = (
  validations: Validation[],
  productOptionTranslations: VariantAttribute[] | null
): Validation[] => {
  const sortedValidations =
    validations?.sort((a, b) => {
      const rankA = a.rank || 0;
      const rankB = b.rank || 0;
      return rankA - rankB;
    }) ?? null;

  sortedValidations?.forEach(validation => {
    if (validation.productOptionKey && validation.tokenValues?.attributeValue) {
      const translatedValue = getTranslatedNameForProductOptionValue(
        productOptionTranslations,
        validation.productOptionKey,
        validation.tokenValues.attributeValue
      );

      if (translatedValue) {
        validation.tokenValues.attributeValue = translatedValue;
      }
    }
  });

  return sortedValidations;
};
